/*
 * Brands carousel — chapter VIII mobile ONLY.
 * Infinite-loop seamless: il track contiene le 5 slide originali + 5 clonate.
 * Un'animation CSS scrolla orizzontalmente fino a -50% e ricomincia → continuità infinita
 * senza scatti. Le 3 slides primarie sono sempre visibili nel viewport (110px + gap 14).
 *
 * Pausa al touch/click (toggles .is-paused), riprende dopo 4s di inattività.
 * Su desktop il JS non fa nulla (early return).
 */
(function () {
  if (typeof document === 'undefined') return;

  function init() {
    if (!document.body.classList.contains('template-page-brands')) return;
    if (!document.body.classList.contains('is-chapter')) return;

    const bp = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--off-breakpoint-desktop'));
    const mq = window.matchMedia(`(max-width: ${(Number.isFinite(bp) ? bp : 1200) - 0.02}px)`);
    if (!mq.matches) return;

    const top = document.querySelector('.off-zone--top');
    if (!top) return;

    // Evita doppia inizializzazione
    if (top.querySelector('.brands-carousel')) return;

    const allChildren = Array.from(top.children);
    const imgs = allChildren.filter(el =>
      el.matches('figure.chapter-image, div.chapter-image') &&
      el.getAttribute('data-visibility') !== 'mobile_only'
    );
    const caps = allChildren.filter(el =>
      el.matches('[class*="off-text-small"]') &&
      /©/.test(el.textContent || '')
    );

    if (imgs.length < 2) return;

    // Container outer (overflow hidden) + inner track (animated)
    const carousel = document.createElement('div');
    carousel.className = 'brands-carousel';
    carousel.setAttribute('aria-roledescription', 'carousel');
    carousel.setAttribute('aria-label', 'Brand partners');

    const track = document.createElement('div');
    track.className = 'brands-carousel__track';
    carousel.appendChild(track);

    function cloneForCarousel(el) {
      const c = el.cloneNode(true);
      c.removeAttribute('data-visibility');
      c.removeAttribute('style'); // toglie grid-column / --off-col-m / etc.
      return c;
    }

    function appendSlideSet() {
      imgs.forEach((img, i) => {
        const cap = caps[i];
        const slide = document.createElement('div');
        slide.className = 'brands-carousel__slide';
        slide.setAttribute('aria-hidden', 'false');
        slide.appendChild(cloneForCarousel(img));
        if (cap) slide.appendChild(cloneForCarousel(cap));
        track.appendChild(slide);
      });
    }

    // Inserisce DUE set identici (originale + clonato) per loop seamless via translateX(-50%).
    appendSlideSet();
    appendSlideSet();
    // Marca i cloni come aria-hidden (a11y: il secondo set è una copia decorativa)
    Array.from(track.children).slice(imgs.length).forEach(s => s.setAttribute('aria-hidden', 'true'));

    // Nasconde gli originali (display:none mobile via .is-carousel-hidden)
    imgs.concat(caps).forEach(el => el.classList.add('is-carousel-hidden'));

    top.insertBefore(carousel, top.firstChild);

    // Pausa al touch/click — riprende dopo 4s di inattività
    let resumeTimer = null;
    function pauseTemporarily() {
      carousel.classList.add('is-paused');
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => carousel.classList.remove('is-paused'), 4000);
    }
    carousel.addEventListener('pointerdown', pauseTemporarily, { passive: true });

    // Cleanup completo se passa a desktop
    mq.addEventListener('change', e => {
      if (!e.matches) {
        carousel.remove();
        imgs.concat(caps).forEach(el => el.classList.remove('is-carousel-hidden'));
      }
    });
  }

  // Init non visual-critical: differito a idle (convenzione MadeInEvolve).
  var idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(init); }, { once: true });
  } else {
    idle(init);
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
